import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import { statDynaProperties } from "./static_dynamic_properties";
import MetaPropertiesAccordion from "./MetaPropertiesAccordion";
import Select from "react-select";
import store from "../../helpers/store/Store";
import {
  updateDynaPropValues,
  updateTagsCatsList,
  updateSelectedPropValues,
  updateSelectedSchedule,
  updateShowAll,
  updateShowSelection,
  updateAdditionalTabs,
} from "../../helpers/actions/Action";
import { HOST_URL } from "../../helpers/constants/Constants";
import exportFromJSON from "export-from-json";
import { ScheduleCategories } from "./ScheduleCategories";
import MetaPropertiesTagList from "./MetaPropertiesTagList";
import MetaPropertiesPropValueList from "./MetaPropertiesPropValueList";
import PClothFilterDS from "./dataSheets/PClothFilterDS";
import PumpDS from "./dataSheets/PumpDS";
import FormikPClothFilterDS from "./dataSheets/FormikPClothFilterDS";
import ValveSchedule from "./schedules/ValveSchedule";
import InstrumentSchedule from "./schedules/InstrumentSchedule";
import EquipmentSchedule from "./schedules/EquipmentSchedule";
import PipelineSchedule from "./schedules/PipelineSchedule";
import PressureTestSchedule from "./schedules/PressureTestSchedule";
import SapSchedule from "./schedules/SapSchedule";


class MetaProperties extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // showAll: false,
      // showSelection: false,
      appliedFilter: "All Classes",
      // selectedTag: "",
      browseMode: true,
      dynaPropList: [],
      elemTagsCatsList: [],
      dataSheetSelected: "",
      scheduleSelected: "",
      data: [],
    };
  }

  handleSaveButtonClick = () => {
    var formDataDynamic = new FormData();
    formDataDynamic.append("Data", JSON.stringify(this.props.dynaPropValues));
    var savedStatic = false,
      savedDynamic = false;

    axios({
      method: "post",
      url: HOST_URL + `/api/savedynamic`,
      data: formDataDynamic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        savedDynamic = true;
        if (savedStatic && savedDynamic) {
          alert("Data Saved");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    var formDataStatic = new FormData();
    formDataStatic.append("Data", JSON.stringify(this.props.statPropValues));

    axios({
      method: "post",
      url: HOST_URL + `/api/savestatic`,
      data: formDataStatic,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then(() => {
        savedStatic = true;
        if (savedStatic && savedDynamic) {
          alert("Data Saved");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // var formDataTabs = new FormData()
    // formDataTabs.append("ElemWithProps",JSON.stringify(this.props.elemWithProperties))
    // formDataTabs.append("Categories",JSON.stringify(this.props.categories))
    // formDataTabs.append("DynaPropValues",JSON.stringify(this.props.dynaPropValues))
    // formDataTabs.append("StatPropValues",JSON.stringify(this.props.statPropValues))
    // formDataTabs.append("FileName",this.props.selectedModel.fileName)

    var data = {
      ElemWithProps: JSON.stringify(this.props.elemWithProperties),
      Categories: JSON.stringify(this.props.categories),
      DynaPropValues: JSON.stringify(this.props.dynaPropValues),
      StatPropValues: JSON.stringify(this.props.statPropValues),
    };

    const tabSize =
      data.ElemWithProps.length +
      data.Categories.length +
      data.DynaPropValues.length +
      data.StatPropValues.length;

    // console.log("tabSize", tabSize);
    if (tabSize > 4700000) {
      store.dispatch(updateAdditionalTabs(false));
    } else {
      //redux state to change tab possible to true
      store.dispatch(updateAdditionalTabs(true));

      window.sessionStorage.setItem(
        this.props.selectedModel.fileName,
        JSON.stringify(data)
      );
    }

    // axios({
    //   method: "post",
    //   url: HOST_URL + `/api/savetabdata`,
    //   data: formDataTabs,
    //   headers: {
    //     "Content-Type": "multipart/form-data"
    //   }
    // })
    // .catch((error) => {
    //   console.log(error)
    // })
  };

  handleGenrateReportButtonClick = (ele) => {
    if (this.props.selectedProject.text === "") {
      alert("Project name not found");
      return;
    }
    var scheduleType = ele.target.name;

    var formData = new FormData();
    formData.append("ProjectName", this.props.selectedProject.text);
    formData.append("ScheduleType", scheduleType);
    formData.append("ScheduleCategories", JSON.stringify(ScheduleCategories));
    formData.append("FileName", this.props.selectedModel.fileName);
    var fileName =
      this.props.selectedProject.text + "_" + scheduleType + ".xlsx";
    axios.defaults.withCredentials = true;
    axios({
      method: "post",
      url: HOST_URL + `/api/getreport`,
      data: formData,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        alert("Schedule saved to BIM 360");
        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', fileName);
        // link.click();
        // const data = {data:response.data, fileName:"download",exportType:exportFromJSON.types.xls}
        // exportFromJSON(data)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleBrowseFilterChange = (selectedObject) => {
    this.setState({
      appliedFilter: selectedObject.value,
    });
  };

  handleEditPropertySelectChange = (selectedObjects) => {
    var tempSelectedPropValues = [];
    if (selectedObjects == null) {
      return;
    }
    selectedObjects.forEach((selectedObject) => {
      var isExists = false;
      this.props.selectedPropValues.forEach((selectedPropValue) => {
        if (!isExists && selectedObject.value == selectedPropValue.propName) {
          isExists = true;
          tempSelectedPropValues.push(selectedPropValue);
        }
      });

      if (!isExists) {
        tempSelectedPropValues.push({
          propName: selectedObject.value,
          propValue: "",
        });
      }
    });
    store.dispatch(updateSelectedPropValues(tempSelectedPropValues));
  };

  handleEditClassSelectChange = (selectedObject) => {
    this.setState(
      {
        appliedFilter: selectedObject.value,
      },
      this.createTagsCatsList
    );
    store.dispatch(updateSelectedPropValues([]));
  };

  createTagsCatsList = () => {
    if (this.props.elemWithProperties.length === 0) {
      return;
    }

    var tempElemTagsCatsList = [];
    var tempDynaPropList = [];

    this.props.elemWithProperties.forEach((elem, index) => {
      if (elem.category == this.state.appliedFilter) {
        tempElemTagsCatsList.push({
          tag: elem.tag,
          category: elem.category,
          isSelected: false,
        });

        if (tempDynaPropList.length === 0) {
          tempDynaPropList = elem.dynaProps;
        }
      }
    });

    this.setState(
      {
        dynaPropList: tempDynaPropList,
        elemTagsCatsList: tempElemTagsCatsList,
      },
      this.dispatchToStore
    );
  };

  dataSheetSelectHandler = (e) => {
    this.setState({
      dataSheetSelected: e.target.value,
    });
  };
  scheduleSelectHandler = (e) => {
    store.dispatch(updateSelectedSchedule(e.target.value));
  };

  dispatchToStore = () => {
    store.dispatch(updateTagsCatsList(this.state.elemTagsCatsList));
  };

  render() {
    return (
      <div>
        <div className="row">
          <h4>
            **This tool is only useable on projects that were created from
            February 2022**
          </h4>
        </div>
        <div className="row">
          <h2>Document editing section</h2>
        </div>
        <div>
          <p>
            This section is where you can view and edit objects withing the
            model or P&ID that is open but in a familiar format like a schedule
            or data sheet(coming soon).
          </p>
          {/* <p>
            If you make any changes to an object within a P&ID it will directly
            change the object with the same tag within the 3D model.
          </p> */}
        </div>
        <div className="row">
          <h4>Data sheets</h4>
        </div>

        <div className="row">
          <div className="col-8">
            <select
              value={this.state.dataSheetSelected}
              onChange={this.dataSheetSelectHandler}
              placeholder="Select Data Sheet"
              style={{ width: "100%" }}
            >
              <option value="">IN DEVELOPMENT</option>
              {/* <option value="pump">Pump</option>
              <option value="clothFilter">P Cloth Filter</option> */}
            </select>
          </div>
          <div className="col-4">
            <button
              type="button"
              className={
                this.state.dataSheetSelected === ""
                  ? "btn btn-primary btn-block mb-2 disabled"
                  : "btn btn-primary btn-block mb-2"
              }
              data-toggle="modal"
              data-target={
                this.state.dataSheetSelected === "" ? "" : "#dataSheetModal"
              }
            >
              Open Data Sheet
            </button>
          </div>
        </div>

        <div
          className="modal modal-page fade"
          id="dataSheetModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="dataSheetModalLabel"
          data-animation="false"
        >
          {/* {this.state.dataSheetSelected === "clothFilter" ? (
            <FormikPClothFilterDS project={this.props.selectedProject} />
          ) : (
            <></>
          )}
          {this.state.dataSheetSelected === "pump" ? <PumpDS /> : <></>} */}
        </div>
        <div className="row">
          <h4>Schedules</h4>
        </div>

        <div className="row">
          <div className="col-8">
            <select
              value={this.props.selectedSchedule}
              onChange={this.scheduleSelectHandler}
              placeholder="Select schedule"
              style={{ width: "100%" }}
            >
              <option value="">Please select a schedule</option>
              <option value="valve">Valve</option>
              <option value="equipment">Equipment</option>
              <option value="instrument">Instrument</option>
              <option value="pipeline">Pipeline</option>
              <option value="sap">Sap</option>

              {/* <option value="pressureTest">Pressure Test</option> */}
            </select>
          </div>
          <div className="col-4">
            <button
              type="button"
              className={
                this.props.selectedSchedule === ""
                  ? "btn btn-primary btn-block mb-2 disabled"
                  : "btn btn-primary btn-block mb-2"
              }
              data-toggle="modal"
              data-target={
                this.props.selectedSchedule === "" ? "" : "#scheduleModal"
              }
            >
              Open Schedule
            </button>
          </div>
        </div>

        <div
          className="modal modal-page fade"
          id="scheduleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="scheduleModalLabel"
          data-animation="false"
        >
          {this.props.selectedSchedule === "valve" ? (
            <ValveSchedule project={this.props.selectedProject} />
          ) : (
            <></>
          )}
          {this.props.selectedSchedule === "instrument" ? (
            <InstrumentSchedule project={this.props.selectedProject} />
          ) : (
            <></>
          )}
          {this.props.selectedSchedule === "equipment" ? (
            <EquipmentSchedule project={this.props.selectedProject} />
          ) : (
            <></>
          )}
          {this.props.selectedSchedule === "pipeline" ? (
            <PipelineSchedule project={this.props.selectedProject} />
          ) : (
            <></>
          )}
          {this.props.selectedSchedule === "pressureTest" ? (
            <PressureTestSchedule project={this.props.selectedProject} />
          ) : (
            <></>
          )}
          {this.props.selectedSchedule === "sap" ? (
            <SapSchedule project={this.props.selectedProject} />
          ) : (
            <></>
          )}
        </div>
        <div>
          <h2>Model object editing section</h2>
        </div>
        <div>
          <p>
            This section is where you can edit objects within the model or P&ID
            that is open.
          </p>
          <p>
            If you make any changes to an object within a P&ID it will directly
            change the object with the same tag within the 3D model.
          </p>
        </div>

        <div>
          <p>
            Instruction:- Select an object on the 3D model or P&ID to start
            editing the dynamic properties or viewing the static ones.
          </p>
        </div>
        {this.state.browseMode ? (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <p className="btn-group">
                <button
                  className="btn btn-primary"
                  style={{ marginRight: ".3rem" }}
                  onClick={(e) => {
                    store.dispatch(updateShowAll(true));
                    store.dispatch(updateShowSelection(false));
                    // this.setState({
                    //   showAll: true,
                    //   showSelection: false,
                    //   appliedFilter: "All Classes",
                    // });
                  }}
                >
                  Show All
                </button>
                {/* <button
                  className="btn btn-secondary"
                  style={{ marginLeft: ".3rem" }}
                  onClick={(e) => {
                    this.props.selectedTag === ""
                      ? alert("Select an element and press show selection.")
                      : this.setState({
                          selectedTag: this.props.selectedTag,
                          showAll: false,
                          showSelection: true,
                        });
                  }}
                >
                  Show Selected
                </button> */}
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: ".3rem" }}
                  onClick={this.handleSaveButtonClick}
                >
                  {" "}
                  Save Data{" "}
                </button>
              </p>
            </div>
            <Select
              //classNamePrefix={'typeahead-select'}
              //value={"selectedOption"}
              onChange={this.handleBrowseFilterChange}
              options={[{ value: "All Classes", label: "All Classes" }].concat(
                this.props.categories.map((category) => {
                  return { value: category, label: category };
                })
              )}
              //getOptionLabel={option => option.text}
              //getOptionValue={option => option.text}
              placeholder="Select Object Type"
            />
            <br />
            {this.props.showAll ? (
              this.props.elemWithProperties.map((elem, index) => {
                if (
                  elem.category == this.state.appliedFilter ||
                  this.state.appliedFilter == "All Classes"
                ) {
                  return (
                    <MetaPropertiesAccordion
                      eleCategory={elem.category}
                      elemName={elem.tag}
                      statProps={elem.statProps}
                      index={index}
                      propertyValues={elem.propertyValues}
                      locked={elem.locked}
                    />
                  );
                }
              })
            ) : this.props.showSelection ? (
              this.props.selectedTag !== "" ? (
                this.props.elemWithProperties.map((elem, index) => {
                  if (elem.tag === this.props.selectedTag) {
                    console.log("elem - ",elem);
                    return (
                      <MetaPropertiesAccordion
                        eleCategory={elem.category}
                        elemName={elem.tag}
                        statProps={elem.statProps}
                        index={index}
                        propertyValues={elem.propertyValues}
                        locked={elem.locked}
                      />
                    );
                  }
                })
              ) : (
                <>
                  <div className="row d-flex justify-content-center">
                    <h3>No tag present on selected object</h3>
                    {/* <h3>Please select a different object</h3> */}
                  </div>
                  <div className="row d-flex justify-content-center">
                    {/* <h3>No tag present on selected object!</h3> */}
                    <h3>Please select a different object</h3>
                  </div>
                </>
              )
            ) : null}
          </div>
        ) : (
          <div>
            {/* <p className="btn-group">
              <button
                className="btn btn-secondary"
                style={{ marginRight: ".3rem" }}
                onClick={this.handleSaveButtonClick}
              >
                {" "}
                Save Data{" "}
              </button>
            </p>
            <br />
            <Select
              //classNamePrefix={'typeahead-select'}
              // value={"selectedOption"}
              onChange={this.handleEditClassSelectChange}
              options={this.props.categories.map((category) => {
                return { value: category, label: category };
              })}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              placeholder="Select Object Type"
            />
            <br />
            <h3>Object Type Table</h3>
            <br />
            <MetaPropertiesTagList />
            <br />
            <Select
              //classNamePrefix={'typeahead-select'}
              //value={"selectedOption"}
              onChange={this.handleEditPropertySelectChange}
              isMulti
              options={this.state.dynaPropList.map((propName) => {
                return { value: propName, label: propName };
              })}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              placeholder="Select Properties"
            />
            <br />
            <h3>Object Properties Table</h3>
            <br />
            <MetaPropertiesPropValueList />
            <br /> */}
          </div>
        )}

        <br />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // dynaPropValuesStore: state.metaPropReducer.dynaPropValues,

  selectedProject: state.getSelectedProjectReducer.data,
  selectedModel: state.getSelectedModelReducer.data,
  elemWithProperties: state.metaPropReducer.elementWithProperties,
  categories: state.metaPropReducer.categories,
  selectedTag: state.metaPropReducer.selectedTag,
  selectedGuId: state.metaPropReducer.selectedGuId,
  dynaPropValues: state.metaPropReducer.dynaPropValues,
  statPropValues: state.metaPropReducer.statPropValues,
  selectedPropValues: state.metaPropReducer.selectedPropValues,
  selectedSchedule: state.metaPropReducer.selectedSchedule,
  showAll: state.metaPropReducer.showAll,
  showSelection: state.metaPropReducer.showSelection,
});

export default connect(mapStateToProps)(MetaProperties);
